import { AuthenticationService } from './service/authentication/authentication.service';
import { PerfilService } from './service/perfil/perfil.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxMaskModule } from 'ngx-mask';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CustomHttpClient, CustomHttpClientCreator } from './providers/CustomHttpClient';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
 
import { NgxUploaderModule } from 'ngx-uploader';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule, Routes } from '@angular/router';
import { routing } from './app.routes';
 
import { AppComponent } from './app.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { CupomComponent, ModalContentComponent, ModalContentGerarCupomComponent } from './pages/cupom/cupom.component';
import { CupomService } from './service/cupom/cupom.service';
import { LayoutComponent } from './pages/layout/layout.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './_guards/AuthGuard';
import { LoginComponent } from './pages/login/login.component';
import { GerenciaComponent } from './pages/gerencia/gerencia.component';
import { UploadCargaComponent } from './pages/upload-carga/upload-carga.component';
import { RelatorioComponent, ModalContentGerarRelatorioComponent  } from './pages/relatorio/relatorio.component';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { RessarcimentoWindowModule } from './modules/modals/ressarcimento.window.module';
import { DataService } from './service/data/data.service'; 
import { UploadCargaService } from './service/upload-carga/upload-carga.service';
import { DataTableModule } from "angular-6-datatable";

import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { ModuloService } from './service/modulo/modulo.service';
import { RedeCredenciadaService } from './service/rede-credenciada/rede-credenciada.service';
import { RedeCredenciadaComponent } from './pages/rede-credenciada/rede-credenciada.component';

@NgModule({
  declarations: [
    AppComponent,
    ModalContentComponent,
    ModalContentGerarCupomComponent,
    ModalContentGerarRelatorioComponent,
    CupomComponent,
    PerfilComponent,
    LayoutComponent,
    HomeComponent,
    LoginComponent,
    GerenciaComponent,
    UploadCargaComponent,
    RelatorioComponent,
    AlterarSenhaComponent,
    RedeCredenciadaComponent
  ],
  entryComponents: [ModalContentComponent, ModalContentGerarCupomComponent, ModalContentGerarRelatorioComponent],
  imports: [
    BrowserModule,
    NgMultiSelectDropDownModule.forRoot(),
    RouterModule, 
    FormsModule, 
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    NgxUploaderModule,
    NgSelectModule,
    PasswordStrengthMeterModule,
    NgxPaginationModule,
    ModalModule.forRoot(), 
    NgxMaskModule.forRoot(),
    BsDatepickerModule.forRoot(),
    RessarcimentoWindowModule.forRoot(),
    routing,
    DataTableModule    
  ],

  providers: [AuthGuard, CupomService, PerfilService, DataService, UploadCargaService, ModuloService, RedeCredenciadaService,
    {
    provide: CustomHttpClient,
    useFactory: CustomHttpClientCreator,
    deps: [HttpClient, NgxSpinnerService]
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
